import { loadBundle } from './i18n-store';

/**
 * Envolve o `loadComponent` de uma rota para baixar o bundle de tradução da página
 * **em paralelo** com o chunk dela.
 *
 * Um resolver ou um guard fariam o fetch em série com o carregamento do chunk, somando
 * um round-trip ao tempo até o primeiro paint. Aqui as duas promises saem juntas e a rota
 * só ativa quando ambas resolvem, então a página nunca pinta com chave crua.
 *
 * O nome do bundle é lido de volta por scripts/split-i18n.mjs, que gera o JSON
 * correspondente a partir dos namespaces que o componente e seus imports usam. Trocar a
 * assinatura desta chamada exige ajustar o regex de lá.
 */
export function lazy<T>(bundle: string, load: () => Promise<T>): () => Promise<T> {
  return async () => {
    const [component] = await Promise.all([load(), loadBundle(bundle)]);
    return component;
  };
}
